import { ReactElement } from 'react';
import { Typography, Link } from '@mui/material';

import NoRecordsFoundMessage from '~components/DataTable/NoRecordsFoundMessage';
import { toAbsoluteUrl } from '~utils/assetsHelpers';

const DashboardVariantV2CarrierContentCollectTabDataTableNoDataIndication =
  (): ReactElement => (
    <NoRecordsFoundMessage
      title="No tienes pedidos para gestionar"
      image={{
        src: toAbsoluteUrl('/icons/icon_empty_inbox.png'),
        alt: 'Empty Inbox',
      }}
      description={
        <Typography variant="body2" component="span">
          Aquí verás los pedidos que tus empresas asociadas te envien.
          <br />
          Has click para ver ayuda sobre cómo{' '}
          <Link
            href="https://routix.tawk.help/article/asociar-empresas"
            target="_blank"
            underline="hover"
            fontWeight="bold"
          >
            asociar empresas
          </Link>{' '}
          o{' '}
          <Link
            href="https://routix.tawk.help/article/rutas-de-colecta-y-distribución-de-terceros"
            target="_blank"
            underline="hover"
            fontWeight="bold"
          >
            gestionar pedidos de otras empresas.
          </Link>
        </Typography>
      }
    />
  );

export default DashboardVariantV2CarrierContentCollectTabDataTableNoDataIndication;
